const creditCard = {
    isLoading: {
        form: false,
        list: false,
        IsDefault: {},
        IsDelete: {},
    },
    list: {},
};
const CreditCardReducer = function(state = creditCard, action) {
    switch (action.type) {
        case 'TOGGLE_CREDIT_CARD_LOADING': {
            return {
                ...state,
                isLoading: {
                    ...state.isLoading,
                    [action.key]: action.value,
                },
            };
        }
        case 'TOGGLE_CREDIT_CARD_ROW_LOADING': {
            return {
                ...state,
                isLoading: {
                    ...state.isLoading,
                    [action.key]: {
                        ...state.isLoading[action.key],
                        [action.identifier]: action.value,
                    },
                },
            };
        }
        case 'REPLACE_CREDIT_CARD_LIST': {
            return {
                ...state,
                list: action.value,
            };
        }
        default: {
            return state;
        }
    }
};

export default CreditCardReducer;
